/**
 * KB-META
 * Purpose: Role override service
 * Role: ui.service
 * EntryPoints: set(), persist()
 * Inputs: roles:RoleLevel[]; v:RoleLevel[]
 * Outputs: 
 * Validation: 
 * Dependencies: 
 * Contracts: 
 * Auth&Privacy: auth:none; hipaa:none; pii:none
 * Observability: 
 * Router: shard=partner-portal-cura; H2=component/role-override.service; tags=ui
 * Owner: ; LastReviewed: 2025-08-25
 */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RoleLevel } from './roles';

@Injectable({ providedIn: 'root' })
export class RoleOverrideService {
  private subj = new BehaviorSubject<RoleLevel[] | null>(this.load());
  readonly override$ = this.subj.asObservable();
  set(roles: RoleLevel[] | null) { this.subj.next(roles); this.persist(roles); }
  private load(): RoleLevel[] | null { const raw = localStorage.getItem('roleOverride'); return raw ? JSON.parse(raw) : null; }
  private persist(v: RoleLevel[] | null) { v ? localStorage.setItem('roleOverride', JSON.stringify(v)) : localStorage.removeItem('roleOverride'); }
}


